import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { models } from '../modele/modele-form';
import { constante } from './constant';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import * as XLSX from 'xlsx';
import * as jspdf from 'jspdf';
import * as moment from 'moment';
var activitePrincipals = require('../../../main_sectors.json');
var secteurActivites = require('../../../sectors.json');
var fonctions = require('../../../fonction.json');
var countries = require('../../../countries.json');
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { SubscriptionService } from 'src/app/services/subscription.service';
declare var require: any
@Component({
  selector: 'formulaire',
  templateUrl: './formulaire.component.html',
  styleUrls: ['./formulaire.component.scss'],
  providers: [DatePipe]
})
export class FormulaireComponent implements OnInit {
  @ViewChild('closeBTN') closeBTN: ElementRef;
  @ViewChild('modalOpen') modalOpen: ElementRef;
  @ViewChild('closeBTNRappel') closeBTNRappel: ElementRef;
  @ViewChild('mondevis') mondevis: ElementRef;
  @ViewChild('confirmSwal') private confirmSwal: SwalComponent;
  @ViewChild('confirmSwalFlotte') private confirmSwalFlotte: SwalComponent;
  @ViewChild('confirmSwalVoyage') private confirmSwalVoyage: SwalComponent;
  @ViewChild('confirmSwalPlainte') private confirmSwalPlainte: SwalComponent;
  @ViewChild('confirmSwalRappel') private confirmSwalRappel: SwalComponent;
  section: string = 'css';
  informations;
  currentSection = -1;
  currentType = 0;
  title = "";
  slideData;
  nom = "nom";
  prenom = "prenom";
  telephone = "telephone";
  customerForm: FormGroup;
  formPlainte: FormGroup;
  formRappel: FormGroup
  fieldsPlainte = [{
    label: "Nom",
    field: "nom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prénom",
    field: "prenom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Email",
    field: "email",
    icon: "assets/images/icon-email.svg",
    type: "email",
    isRequired: true,
    class: '',
    validations: [{ name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
  }, {
    label: "Numéro de téléphone",
    field: "telephone",
    icon: "assets/images/icon-telephone.svg",
    type: "tel",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prestataire du réseau de soin",
    field: "prestataire",
    icon: "assets/images/icon-personne-morale.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  },
  {
    label: "Entreprise",
    field: "entreprise",
    icon: "assets/images/icon-personne-morale.svg",
    type: "text",
    class: '',
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  },
  {
    label: "Type plainte",
    field: "type",
    icon: "assets/images/icon-carte-grise.svg",
    type: "select",
    isRequired: true,
    class: '',
    list: [{ name: 'Mauvais accueil', value: 1 }, { name: "Ne travaille plus avec l'assureur", value: 2 }, { name: 'Problème Informatique', value: 3 }, { name: "Retard Prise en charge", value: 4 }, { name: "Autres", value: 5 }],
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Nature plainte",
    field: "autres",
    icon: "assets/images/icon-carte-grise.svg",
    type: "text",
    chieldOther: { name: 'type', value: 5 },
    isRequired: false,
    class: '',
    validations: []
  }, {
    label: "Autres précisions",
    field: "description",
    icon: "assets/images/icon-carte-grise.svg",
    type: "textarea",
    isRequired: false,
    class: '',
    validations: []
  }, {
    label: "Date de l'incident",
    field: "dateIncident",
    icon: "assets/images/icon-date.svg",
    type: "date",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }];
  fieldsRappel = [{
    label: "Nom",
    field: "nom",
    icon: "assets/images/nom.svg",
    type: "text",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Prénom",
    field: "prenom",
    icon: "assets/images/nom.svg",
    type: "text",
    class: '',
    isRequired: true,
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Email",
    field: "email",
    icon: "assets/images/icon-email.svg",
    type: "email",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }, { name: "pattern", value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Ce champ est invalide" }]
  },
  {
    label: "Numéro de téléphone",
    field: "telephone",
    icon: "assets/images/telephone.svg",
    type: "tel",
    isRequired: true,
    class: '',
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  },
  {
    label: "Disponibilité",
    field: "disponibilite",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: true,
    class: '',
    list: [{ name: 'Matin', value: 'Matin' }, { name: 'Soir', value: 'Soir' }, { name: 'Toute la journée', value: 'Toute la journée' }],
    validations: [{ name: "required", value: 'Validators.required', message: "Ce champ est obligatoire" }]
  }, {
    label: "Quelle heure",
    field: "heure",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: false,
    class: '',
    chieldOther: { name: 'disponibilite', value: "Matin" },
    list: [{ name: '08H-10H', value: "08H-10H" }, { name: "10H-12H", value: "10H-12H" }, { name: "12H-14H", value: "12H-14H" }],
    validations: []
  }, {
    label: "Quelle heure",
    field: "heure",
    icon: "assets/images/icon-date.svg",
    type: "select",
    isRequired: false,
    chieldOther: { name: 'disponibilite', value: "Soir" },
    list: [{ name: '15H-16H', value: "15hH-16H" }, { name: "16H-17H", value: "16H-17H" }, { name: "17H-18H", value: "17H-18H" }],
    validations: []
  }];
  errorFileType: boolean = false;
  fields = [];
  newDate = new Date();
  maxDateNaissance = new Date()
  firstClick: boolean = false;
  fileName = "";
  isFlotte = "";
  flotte = "";
  currentForm;
  libelle = "";
  code = "";
  userIP: any;
  errorMontant = "";
  fieldMontant = "";
  formDetails;
  succesForm: boolean = false;
  loadFile: boolean = false;
  currentActionValue;
  currentActionIndex;
  hasPhoneError: boolean;
  isFocus: unknown;
  tabFiles: any = [];
  listSecteurs: any = [];
  listMarques: any = [];
  listCategories: any = [];
  listGarantieVoyage: any = [];
  currentList: any = [];
  listGaranties: any = [];
  listModels: any = [];
  listactivitePrincipal: any = [];
  listActivites: any = [];
  listFonctions: any = [];
  listCountries: any = [];
  dataString: any = [];
  listProduits: any = [];
  listPays: any = [];
  typeProduit = "";
  loader: boolean = false;
  lien = "";
  numDevis = (new Date()).getTime();
  currentPays = "Senegal";
  typeForm = "";
  tabVoyage: any = [];
  currentVoyage;
  tabDevis = [];
  currentVoyageIndex;
  minDateDepart = new Date();
  titleVoyage = "Ajouter un voyage";
  update = false;
  validStep = -1;
  loadDevis: boolean = false;
  listFlotte = [{ name: 'Oui', value: 'oui' }, { name: 'Non', value: 'non' }]
  autreMarqueSelected = false;
  url : string = '';
  lienBrute: String = '';
  urlFile: string = '';
  constructor(private route: ActivatedRoute, private http: HttpClient, private datePipe: DatePipe, private toastr: ToastrService, private authService: AuthService,private subscriptionService : SubscriptionService, private router: Router) {
    // @ts-ignore
    this.lienBrute = this.route.snapshot._routerState.url;
    
    if (this.lienBrute == '/prevoyance-education' || this.lienBrute == '/prevoyance-deces' || this.lienBrute == '/prevoyance-retraite')
      this.lien = 'vie';
    else if (this.lienBrute == '/multirisque-pro' || this.lienBrute == '/multirisque-habitat')
      this.lien = 'multirisque';
    else
      this.lien = this.lienBrute.substring(1, this.lienBrute.length);
    this.informations = models[this.lien];
    this.url = this.informations.url;
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: this.informations.title,
      subTitle: this.informations.subTitle,
      description: this.informations.description,
      img: this.informations.imgBackground,
      type: this.informations.type,
      imgIcon: this.informations.imgIcon
    }];
    this.listactivitePrincipal = activitePrincipals[0]['items'];
    this.listactivitePrincipal.sort(dynamicSort('activitesprincipal'));
    this.listSecteurs = secteurActivites[0]['items'];
    this.listSecteurs.sort(dynamicSort('secteuractivites'));
    this.listFonctions = fonctions[0]['items'];
    this.listFonctions.sort(dynamicSort('name'));
    this.listCountries = countries[0]['items'];
    this.listCountries.sort(dynamicSort('name'));
    for (let fonction of this.listFonctions) {
      fonction['value'] = fonction.name;
    }
    this.listFonctions.unshift({ name: 'Autres', value: 'Autres' });
    // this.listFonctions['value'] = 'Autres';
    // this.listFonctions['name'] = 'Autres';
    for (let secteur of this.listSecteurs) {
      secteur['value'] = secteur.name;
    }
    for (let activite of this.listactivitePrincipal) {
      activite['value'] = activite.name;
    }
    for (let pays of this.listCountries) {
      pays['value'] = pays.name;
    }
  }

  ngOnInit(): void {
    this.loadIp();
    this.getListProduits();
    this.initPlainte();
    this.initRappel();
    // this.getMarque();
    this.getCategorie();
    this.getListPays();
    this.getGarantieVoyage();
    this.getMarquevoiture();
    // this.getModele();
    const before18years: any = moment().subtract(18, 'years');
    this.maxDateNaissance = new Date(before18years);
    let route = localStorage.getItem('route');
    if (route && route != undefined && route != '' && this.informations[route]) {
      this.checkForm(route);
    }
  }

  getMarquevoiture() {
    this.subscriptionService.getModel().subscribe((resp) => {
      let data = resp['data'];
      let value = [];
      for (let val of data) {
        value.push({ name: val.make, value: val.make });
      }
      this.listMarques = value.sort(dynamicSort('name'));
      });
  }

  modelByMarque(dah) {
    if (dah == 'Autre') {
      this.autreMarqueSelected = true;
    } else {
      this.autreMarqueSelected = false;
      this.subscriptionService.getmodel(dah).subscribe((resp) => {
        let data = resp['data'];
        let value = [];
        for (let val of data) {
          value.push({ name: val.model, value: val.model });
        }
        this.listModels = value.sort(dynamicSort('name'));
        let tab = this.currentForm.formulaire.filter(elm => elm.field == 'modele');
        tab[0].list = this.listModels;
      });
    }
  }

//   getGaranties() {
//     this.garanties = [];
//     this.garantiesAll = [];
//     this.subscriptionService.getTypeGaranties().subscribe((resp) => {
//         if (resp['responseCode'] == 200) {
//             this.garanties = resp['data'].filter(el => el.parent_id == null);
//             this.garantiesAll = this.garanties;
//             this.garanties = this.garanties.map(el => {
//                 if (el.code == 'gpt' || el.nom == 'Personne Transportée') {
//                     el.sousGarantie = el.sousGarantie.sort((a, b) => {
//                         return a.id - b.id;
//                     });
//                     ;
//                 }
//                 return el;
//             });

//         }
//     });
//     this.getDescriptionGarantie();
// }
  getMarque() {
    this.authService.getMarques().subscribe(resp => {
      let data = resp['data']['make'];
      let value = [];
      for (let val of data) {
        value.push({ name: val, value: val });
      }
      this.listMarques = value.sort(dynamicSort('name'));
    });
  }
  getTypeValue(val) {
    if (typeof val == 'string')
      return 'string';
    else return 'number';
  }
  getCategorie() {
    this.authService.getCategories().subscribe(resp => {
      let value = resp['data'];
      if (value.length != 0) {
        for (let val of value) {
          val['value'] = val.libelle;
          val['name'] = val.libelle
        }
        this.listCategories = value;

      }
    }, error => {
     
    });
  }
  getGarantieVoyage() {
    let data = {
      filiale: this.currentPays
    }
    this.authService.getGarantieVoyage(data).subscribe(resp => {
      let value = resp['data'];
      if (value.length != 0) {
        for (let val of value) {
          val['value'] = val.type.libelle;
          val['name'] = val.type.libelle
        }
        this.listGarantieVoyage = value;
        if (this.lien == 'voyage' && this.currentSection != -1)
          this.fields[2]['formulaire'][0]['list'] = this.listGarantieVoyage;
      }
    }, error => {
      
    });
  }
  getModele(id) {
    let data = {
      marque: id
    }
    this.authService.getModels(data).subscribe(resp => {
      let data = resp['data']['model'];
      let value = [];
      for (let val of data) {
        value.push({ name: val, value: val });
      }
      this.listModels = value.sort(dynamicSort('name'));
      let tab = this.currentForm.formulaire.filter(elm => elm.field == 'modele');
      tab[0].list = this.listModels;
    });
  }
  getGaranties(id) {
    this.listGaranties = [];
    this.currentList = [];
    let data = {
      categorieId: id,
      filiale: this.currentPays
    }
    this.authService.getGaranties(data).subscribe(resp => {
      let value = resp['data'];
      let data = [];
      if (value.length != 0) {
        for (let val of value) {
          let dataSous = [];
          if (val.sousGarantie.length != 0) {
            for (let garantie of val.sousGarantie) {
              dataSous.push({ 'id': garantie.id, name: garantie.type.libelle, value: garantie.type.libelle });
              this.currentList.push({ 'id': garantie.id, name: garantie.type.libelle, value: garantie.type.libelle });
            }
          }
          data.push({ 'id': val.id, name: val.type.libelle, value: val.type.libelle, sousGarantie: dataSous })
          this.currentList.push({ 'id': val.id, name: val.type.libelle, value: val.type.libelle, sousGarantie: dataSous });
        }
        this.listGaranties = data;
        this.listGaranties.unshift({ name: 'Responsabilité civile', value: 'Responsabilité civile', id: 0, sousGarantie: [] });
        this.fields[2]['formulaire'][0]['list'] = this.listGaranties;
      }
    });
  }
  clearValidatorsMethode(form, tab) {
    for (const key in form.controls) {
      if (tab.indexOf(key) != -1) {
        form.get(key).clearValidators();
        form.get(key).updateValueAndValidity();
        // form.get(key).setValue('');
      }
    }
  }

  setValidatorsMethode(form, tab) {
    for (const key in form.controls) {
      if (tab.indexOf(key) != -1) {
        form.get(key).setValidators(Validators.required);
        form.get(key).updateValueAndValidity();
        // form.get(key).setValue('');
      }
    }
  }

  checkFlotte() {

    if (this.isFlotte == 'oui') {
      this.currentSection = -2;
      let tabValid = ['typeVehicule', 'marque', 'modele', 'matricule', 'chargeUtile', 'nombrePlace', 'puissance', 'dateCirculation', 'nombrePlace1', 'typeMoteur', 'garanties']
      this.clearValidatorsMethode(this.customerForm, tabValid);
    } else {
      let tabValid = ['typeVehicule', 'marque', 'modele', 'matricule', 'puissance', 'dateCirculation', 'typeMoteur', 'garanties']
      this.setValidatorsMethode(this.customerForm, tabValid);
      this.currentSection = this.validStep;
    }
    this.tabFiles = [];
  }
  isValidFlottte() {
    this.firstClick = false;
    if (this.customerForm.invalid && this.isFlotte == 'oui' && this.tabFiles.length == 0) {
      this.firstClick = true;
      this.toastr.warning(
        "Veuillez renseigner tous les champs obligatoires SVP",
        "Attention !!!");
    } else {
      this.confirmSwalFlotte.fire();
    }
  }
  saveDemandeFlotte() {
    this.firstClick = false;
    if (this.customerForm.valid && this.isFlotte == 'oui' && this.tabFiles.length != 0) {
      let value = this.customerForm.value;
      value['isFlotte'] = true;
      value['typeDevis'] = this.typeForm;
      let data = {
        "codeProduit": this.code,
        "statut": 'NON_AFFECTE',
        "pays": this.currentPays,
        "email": this.customerForm.get('email').value,
        "content": JSON.stringify(value)
      }
      this.loader = true;
      this.authService.saveDemande(data).subscribe(resp => {
        if (resp['responseCode'] == 200) {
          this.loader = false;
          if (this.tabFiles.length != 0) {
            for (let files of this.tabFiles) {
              let dataFiles = new FormData();
              dataFiles.append('demande', resp['data']['id']);
              dataFiles.append('nom', files.nom);
              dataFiles.append('files', files.file);
              // this.authService.storeFile(dataFiles).subscribe(val => {
              //   this.loader = false;
              //   this.currentSection = 20;
              //   this.fields = [];
              //   this.informations.typeForm = 2;
              //   this.title = "";
              // }, error => {
              //   this.loader = false;
              //   this.toastr.error(error['error']['errors'][0]['message'], "Erreur !!!");
              // });
            }


          } else {
            this.loader = false;
            this.currentSection = 20;
            this.fields = [];
            this.informations.typeForm = 2;
            this.title = "";
          }

        } else {
          this.toastr.error(resp['errors'][0]['message'], "Erreur !!!");
          this.loader = false;
        }
      }, error => {
        this.loader = false;
        this.toastr.error(error['error']['errors'][0]['message'], "Erreur !!!");
      });
    } else {
      this.firstClick = true;
    }
  }
  getListProduits() {
    this.authService.getProduits().subscribe(resp => {
      this.listProduits = resp['data'];
    });
  }

  getListPays() {
    this.authService.getPays().subscribe(resp => {
      let value = resp['data'];
      for (let val of value) {
        val['value'] = val.nom;
        val['name'] = val.nom;
      }
      this.listPays = value;
    });
  }

  selectList(evt, formcontrol) {
    if (formcontrol == 'secteurActivite') {
      let val = this.customerForm.get(formcontrol).value;
      let tab = this.currentForm.formulaire.filter(elm => elm.field == 'activite');
      tab[0].list = this.listactivitePrincipal.filter(element => element['secteuractivites'] == val);
    }
    if (formcontrol == 'marque') {
      let val = this.customerForm.get(formcontrol).value;
      // let tabIdMarque = this.listMarques.filter(elm => elm.name == val)
      // let idMarque = tabIdMarque[0].id;
      // this.getModele(val);
      this.modelByMarque(val);
    }

    if (formcontrol == 'typeVehicule') {
      let val = this.customerForm.get(formcontrol).value;
      let tabIdCategorie = this.listCategories.filter(elm => elm.name == val)
      let id = tabIdCategorie[0].id;
      if (val == constante.vtp || val == constante.vct) {
        if (val == constante.vtp) {
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'nombrePlace') {
              form.isRequired = true;
            }
            if (form.field == 'chargeUtile') {
              form.isRequired = false;
            }
          }
          this.setValidatorsMethode(this.customerForm, ['nombrePlace']);
          this.customerForm.get('nombrePlace').setValue(5);
          this.clearValidatorsMethode(this.customerForm, ['chargeUtile', 'nombrePlace1']);
        }
        if (val == constante.vct) {
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'nombrePlace1') {
              form.isRequired = true;
            }
            if (form.field == 'chargeUtile') {
              form.isRequired = false;
            }
          }

          this.setValidatorsMethode(this.customerForm, ['nombrePlace1']);
          this.clearValidatorsMethode(this.customerForm, ['chargeUtile', 'nombrePlace']);
        }

        this.getGaranties(id);
      }
      else if (val == constante.vtpm) {
        this.getGaranties(id);
        for (let form of this.currentForm.formulaire) {
          if (form.field == 'nombrePlace1' || form.field == 'nombrePlace') {
            form.isRequired = false;
          }
          if (form.field == 'chargeUtile') {
            form.isRequired = true;
          }
        }
        this.setValidatorsMethode(this.customerForm, ['chargeUtile']);
        this.clearValidatorsMethode(this.customerForm, ['nombrePlace', 'nombrePlace1']);
      } else if (val == constante.vdr) {
        for (let form of this.currentForm.formulaire) {
          if (form.field == 'nombrePlace1' || form.field == 'chargeUtile' || form.field == 'nombrePlace') {
            form.isRequired = false;
          }
        }
        this.getGaranties(id);
        this.clearValidatorsMethode(this.customerForm, ['nombrePlace', 'nombrePlace1', 'chargeUtile']);
      }
      else {
        this.getGaranties(id);
        for (let form of this.currentForm.formulaire) {
          if (form.field == 'nombrePlace1' || form.field == 'chargeUtile' || form.field == 'nombrePlace') {
            form.isRequired = false;
          }
        }
        this.clearValidatorsMethode(this.customerForm, ['nombrePlace', 'chargeUtile', 'nombrePlace1']);
      }
    }
    if (formcontrol == 'duree') {
      if (this.customerForm.get('dateEffet').value != '') {
        let duree = Number(this.customerForm.get('duree').value);
        let expiration = moment(this.customerForm.get('dateEffet').value).add(duree, 'M');
        let dateExpiration = moment(expiration).subtract(1, 'days');
        this.customerForm.get('dateExpiration').setValue(this.datePipe.transform(dateExpiration, 'dd-MM-yyyy'));
      }
    }
    if(formcontrol == 'choixAyant'){
      if(this.customerForm.get('choixAyant').value == 'Ayant-droit')
      this.fields[1].title== "Information de l'ayant-droit";
      else this.fields[1].title = "Information du bénéficiaire";
    }
  }

  addVoyage() {
    if (this.customerForm.get('destination').value == '' || this.customerForm.get("dateDepart").value == '' || this.customerForm.get("dateDarriver").value == '' || this.customerForm.get('duree').value == '') {
      this.firstClick = true;
    } else {
      this.firstClick = false;
      if (!this.update) {
        let data = {
          destination: this.customerForm.get('destination').value,
          dateDepart: this.customerForm.get('dateDepart').value,
          dateDarriver: this.customerForm.get('dateDarriver').value,
          duree: this.customerForm.get('duree').value
        }
        if (this.tabVoyage.length == 0) this.tabVoyage.push(data);
        else this.tabVoyage.unshift(data);
      } else {
        let data = {
          destination: this.customerForm.get('destination').value,
          dateDepart: this.customerForm.get('dateDepart').value,
          dateDarriver: this.customerForm.get('dateDarriver').value,
          duree: this.customerForm.get('duree').value
        }
        this.tabVoyage[this.currentVoyageIndex] = data;
      }
      this.customerForm.get('destination').setValue('');
      this.customerForm.get('dateDepart').setValue('');
      this.customerForm.get('dateDarriver').setValue('');
      this.customerForm.get('duree').setValue('');
    }
  }
  editVoyage() {
    this.titleVoyage = "Modifier un voyage";
    this.update = true;
    this.customerForm.get('destination').setValue(this.currentVoyage.destination);
    this.customerForm.get('dateDepart').setValue(this.currentVoyage.dateDepart);
    this.customerForm.get('dateDarriver').setValue(this.currentVoyage.dateDarriver);
    this.customerForm.get('duree').setValue(this.currentVoyage.duree);
  }
  deletVoyage() {
    this.tabVoyage.splice(this.currentVoyageIndex, 1);
  }
  checkDeletVoyage() {
    this.confirmSwalVoyage.fire();
  }
  checkForm(type) {
    this.typeForm = type;
    this.currentSection = 0;
    this.firstClick = false;
    this.initForm(type);
  }
  setSection(section: string) {
    this.section = section;
  }

  nextStepRecap() {
    this.firstClick = false;
    if (this.lien != 'voyage') {
      if (this.customerForm.invalid || this.hasPhoneError || this.errorMontant != '') {
        this.firstClick = true;
        this.toastr.warning(
          "Veuillez renseigner tous les champs obligatoires SVP",
          "Attention !!!");
      } else this.currentSection += 1;
    } else {
      if (this.tabVoyage.length == 0) {
        if (this.customerForm.invalid || this.hasPhoneError || this.errorMontant != '') {
          this.firstClick = true;
          this.toastr.warning(
            "Veuillez renseigner tous les champs obligatoires SVP",
            "Attention !!!");
        } else this.currentSection += 1;
      }
      if (this.tabVoyage.length != 0) {
        this.currentVoyage = this.tabVoyage[this.tabVoyage.length - 1];
        this.customerForm.get('destination').setValue(this.currentVoyage.destination);
        this.customerForm.get('dateDepart').setValue(this.currentVoyage.dateDepart);
        this.customerForm.get('dateDarriver').setValue(this.currentVoyage.dateDarriver);
        this.customerForm.get('duree').setValue(this.currentVoyage.duree);
        if (this.customerForm.invalid || this.hasPhoneError || this.errorMontant != '') {
          this.firstClick = true;
          this.toastr.warning(
            "Veuillez renseigner tous les champs obligatoires SVP",
            "Attention !!!");
        } else this.currentSection += 1;
      }
    }
  }
  convertTable(value) {
    return value.split(',');
  }
  getFile(e, formcontrol, label,allowed_types) {
    if (e.target.files && e.target.files[0]) {
      let index = e.target.files[0].name.lastIndexOf(".");
      let strsubstring = e.target.files[0].name.substring(index, e.target.files[0].name.length);
      // let allowed_types = [];
      // if (formcontrol == 'carteGrise')
      //   allowed_types = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
      // else if (formcontrol == 'carteGrise')
      //   allowed_types = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowed_types.includes(strsubstring)) {
        this.errorFileType = true;
      } else this.errorFileType = false;
      if (!this.errorFileType) {
        this.fileName = e.target.files[0].name;
        let docBase64Path: any;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          docBase64Path = e.target.result;
        }
        this.tabFiles.push({ formControl: formcontrol, nom: label, file: e.target.files[0], docBase64Path: docBase64Path, type: e.target.files[0].type });
      } else {
        this.customerForm.get(formcontrol).setValue('');
        this.fileName = "";
      }
    }
  }

  onFileChange(evt: any) {
    let index = evt.target.files[0].name.lastIndexOf(".");
    let strsubstring = evt.target.files[0].name.substring(index, evt.target.files[0].name.length);
    if (strsubstring != '.xlsx' && strsubstring != '.XLSX') {
      this.toastr.warning("Le fichier doit être au format excel", "Attention !!!");
    } else {
      this.loadFile = true;
      const target: DataTransfer = <DataTransfer>(evt.target);
      if (target.files && target.files[0]) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        const file = evt.target.files[0];
        this.tabFiles.push({ nom: "Flotte automobile", file: evt.target.files[0] });
        this.fileName = evt.target.files[0].name;
        reader.onload = (event) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary' });
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet);
            return initial;
          }, {});
          this.loadFile = false;
          this.saveFile(evt.target.files[0]);
        }
        reader.readAsBinaryString(file);
      } else {
        this.loadFile = false;
      }
    }
  }
  checkNumberValue(formcontrol) {
    let value = this.customerForm.get(formcontrol).value;
    if (value != '' && (formcontrol == 'enfant' || formcontrol == 'enfantMajeur' || formcontrol == 'assurePincipale' || formcontrol == 'conjoint')) {
      let pop = Number(this.customerForm.get('enfant').value) + Number(this.customerForm.get('enfantMajeur').value) + Number(this.customerForm.get('assurePincipale').value) + Number(this.customerForm.get('conjoint').value);
      this.customerForm.get("effectif").setValue(pop);
    }
  }
  /**
  * Récupération de la liste des pays avec leurs indicatifs et leurs drapeaux
  */
  hasError(ev, field, form) {
    this.hasPhoneError = !ev ? true : false;
    let currentValue = this[form].get(field).value;
    if (this.currentPays == 'Côte d’Ivoire' && this.hasPhoneError) {
      if (currentValue != '') {
        if (currentValue.includes("+225") && currentValue.length != 14) {
          this.hasPhoneError = true;
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
        } else if (currentValue.length == 10 && !currentValue.includes("+225")) {
          this.hasPhoneError = false;
          let value = '+225' + currentValue;
          this[form].get(field).setValue(value);
        } else if (currentValue.includes("+225") && currentValue.length == 14) {
          let val = currentValue.replace('+225', '');
          this[form].get(field).setValue(val);
          this.hasPhoneError = false;
        }
      }
    } else if (this.currentPays == 'Côte d’Ivoire' && !this.hasPhoneError) {
      let val = currentValue.replace('+225', '');
      this[form].get(field).setValue(val);
      this.hasPhoneError = true;
    }
  }
  getNumber(ev, field, form) {
    if (this.currentPays != 'Côte d’Ivoire')
      this[form].get(field).setValue(ev);
  }
  telInputObject(ev) {
    // console.log("telNUm-EV",ev);
  }
  parseIntValue(value) {
    return parseInt(value);
  }
  onCountryChange(ev) {
    let value = ev['name'].toString();
    let val = "";
    for (let i = 0; i < value.length; i++) {
      if (value[i] == '(') {
        val = value.substring(0, i - 1);
        this.currentPays = val;

      } else {
        this.currentPays = value;
      }
    }
    if (this.customerForm.get('territorialite')) {
      let tabVal = this.fields.filter(elm => elm.field == 'territorialite');
      if (tabVal.length != 0) {
        tabVal[0].list[0] = { name: val, value: val }
      }
      let tab = this.currentForm.formulaire.filter(elm => elm.field == 'territorialite');
      if (tab.lenght != 0) {
        tab[0].list[0] = { name: val, value: val }
      }
    }
    if (this.lien == 'voyage')
      this.getGarantieVoyage();
  }

  getDevis() {
    if (this.lien == 'auto') {
      this.tabDevis = [];
      this.loadDevis = true;
      let typeVehicule;
      let garanties: any = [];
      let tab = this.listCategories.filter(el => el.name == this.customerForm.get('typeVehicule').value)
      if (tab.length != 0)
        typeVehicule = tab[0].id;

      for (let garantie of this.currentList) {
        if (this.customerForm.get('garanties').value.indexOf(garantie.name) != -1) {
          garanties.push(garantie.id)
        }
      }
      let value = {
        "typeVehicule": typeVehicule,  // id du type de vehicule  1
        "valeurNeuf": this.customerForm.get('valeurNeuf').value,  //  valeure neuve
        "duree": this.customerForm.get('duree').value,  //  valeure neuve
        "valeurVenal": this.customerForm.get('valeurVenal').value,  // valeure actuelle de la voiture
        "puissance": this.customerForm.get('puissance').value, // puissance de la voiture
        "typeMoteur": this.customerForm.get('typeMoteur').value,  // peu prendre comme valeur Essence ou Diesel
        "garanties": garanties, // tableau des identifiants des categories
        "nombrePlace": this.customerForm.get('nombrePlace').value || this.customerForm.get('nombrePlace1').value, // nombre de places
        "poids": this.customerForm.get('chargeUtile').value // poids du vehicule a env
      }

      this.authService.getDevis(value).subscribe((data: any) => {
        this.loadDevis = false;
        if (data.length != 0) {
          this.tabDevis = data["resultat"];
        }
      }, error => {
        this.loadDevis = false;
        this.toastr.error(error['errors'][0]['message'], 'Attention !!!');
      });
    }

    if (this.lien == 'voyage') {
      this.tabDevis = [];
      this.loadDevis = true;
      let paysDepart;
      let paysArrive;
      let tabDepart = this.listPays.filter(el => el.name == this.customerForm.get('paysResidence').value)
      if (tabDepart.length != 0)
        paysDepart = tabDepart[0].id;
      let tabArriver = this.listPays.filter(el => el.name == this.customerForm.get('destination').value)
      if (tabArriver.length != 0)
        paysArrive = tabArriver[0].id;
      let age = moment(new Date()).diff(this.customerForm.get('dateNaiss').value, 'year');
      if (age == 0)
        age = 1;
      let value = {
        "age": age,
        "paysDepart": paysDepart,
        "paysArrive": paysArrive,
        "duree": this.customerForm.get('duree').value
      }

      this.authService.getDevisVoyage(value).subscribe((resp: any) => {
        this.loadDevis = false;
        if (resp['data'].length != 0) {
          this.tabDevis = resp['data'];
        }
      }, error => {
        this.loadDevis = false;
        this.toastr.error(error['errors'][0]['message'], 'Attention !!!');
      });
    }
  }
  checkFormDevis() {
    this.confirmSwal.fire();
  }
  loadIp() {
    this.http.get('https://jsonip.com')
      .pipe(
        switchMap((value: any) => {
          this.userIP = value.ip;
          let url = `http://api.ipstack.com/${value.ip}?access_key=AIzaSyAwMP4QNMrB3z7ozZAMKOb1sQpk5eKJLFg`
          return this.http.get(url);
        })
      ).subscribe(
        (value: any) => {
         
        },
        err => {
         
        }
      );
  }
  checkFormPlainte() {
    if (this.formPlainte.invalid || this.hasPhoneError) {
      this.firstClick = true;
    } else {
      this.firstClick = false;
      this.confirmSwalPlainte.fire();
    }
  }

  checkFormRappel() {
    if (this.formRappel.invalid || this.hasPhoneError) {
      this.firstClick = true;
    } else {
      this.firstClick = false;
      this.confirmSwalRappel.fire();
    }
  }
  soumettre() {
    this.loader = true;
    let value = this.customerForm.value;
    if (this.lien == 'voyage' && this.tabVoyage.length != 0)
      value['listVoyage'] = this.tabVoyage;

    if (this.lienBrute == '/auto')
      value['urlFile'] = this.urlFile;

    value['typeDevis'] = this.typeForm;
    let data = {
      "codeProduit": this.code,
      "statut": 'NON_AFFECTE',
      "pays": this.currentPays,
      "email": this.customerForm.get('email') ? this.customerForm.get('email').value : null,
      "content": JSON.stringify(value),
      "typeRisque": this.informations.typeRisque,
      "designationClient": (this.customerForm.get('nom') && this.customerForm.get('prenom')) ? this.customerForm.get('nom').value + ' ' + this.customerForm.get('prenom').value : this.customerForm.get('name') ? this.customerForm.get('name').value : this.customerForm.get('nomEntreprise') ? this.customerForm.get('nomEntreprise').value : null,
      "telephone": this.customerForm.get('telephone') ? this.customerForm.get('telephone').value : null,
      "adresse": this.customerForm.get('adresse') ? this.customerForm.get('adresse').value : null,
    }
    if (this.lienBrute == '/multirisque-habitat')
      data['typeRisque'] = 'MRH';

    if (this.lienBrute == '/prevoyance-education')
      data['typeRisque'] = 'EDUCATION';

    if (this.lienBrute == '/prevoyance-deces')
      data['typeRisque'] = 'PREVOYANCE';

    if (this.lienBrute == '/prevoyance-retraite')
      data['typeRisque'] = 'RETRAITE';
      
    this.authService.saveDemande(data,this.url).subscribe(resp => {
      if (resp['responseCode'] == 200) {
        let i = 0;
        // if (this.tabFiles.length != 0) {
        //   for (let files of this.tabFiles) {
        //     let dataFiles = new FormData();
        //     dataFiles.append('demande', resp['data']['id']);
        //     dataFiles.append('nom', files.nom);
        //     dataFiles.append('files', files.file);
        //     // this.authService.storeFile(dataFiles).subscribe(val => {
        //     //   this.loader = false;
        //     //   if ((this.lien == 'auto') && (this.isFlotte == 'non' || this.isFlotte == '')) {
        //     //     this.loader = false;
        //     //     this.getDevis();
        //     //     this.modalOpen.nativeElement.click();
        //     //   } else {
        //     //     this.loader = false;
        //     //     this.currentSection = 20;
        //     //     this.fields = [];
        //     //     this.informations.typeForm = 2;
        //     //     this.title = "";
        //     //     this.customerForm.reset();
        //     //   }
        //     // }, error => {
        //     //   this.loader = false;
        //     //   this.toastr.error(error['error']['errors'][0]['message'], "Erreur !!!");
        //     // });

        //     this.loader = false;
        //     this.currentSection = 20;
        //     this.fields = [];
        //     this.informations.typeForm = 2;
        //     this.title = "";
        //     this.customerForm.reset();
        //   }

        // } else {
          if ((this.lien == 'auto') && (this.isFlotte == 'non' || this.isFlotte == '')) {
            this.loader = false;
            this.getDevis();
            this.modalOpen.nativeElement.click();
          } else {
            this.loader = false;
            this.currentSection = 20;
            this.fields = [];
            this.informations.typeForm = 2;
            this.title = "";
            this.customerForm.reset();
          }
        // }

      } else {
        this.toastr.error(resp['errors'][0]['message'], "Erreur !!!");
        this.loader = false;
      }
    }, error => {
      this.loader = false;
      this.toastr.error(error['error']['errors'][0]['message'], "Erreur !!!");
    });

  }

  resetForm() {
    this.currentSection = -1;
    this.fields = [];
    this.informations.typeForm = 2;
    this.title = "";
    this.customerForm.reset();
  }
  savePlainte() {
    this.loader = true;
    let value = this.formPlainte.value;
    // if(this.formPlainte.get('autres').value!=''){
    //   this.formPlainte.get('type').setValue(this.formPlainte.get('autres').value);
    // }
    value['date'] = new Date();
    value["pays"] = this.currentPays,
      this.authService.savePlainte(value).subscribe(resp => {
        if (resp['responseCode'] == 200) {
          this.loader = false;
          this.toastr.success('Plainte envoyée avec succès', 'Succès');
          this.closeBTN.nativeElement.click();
        } else {
          this.loader = false;
          this.toastr.error('Erreur sur le serveur', 'Attention !!!');
        }
      }, error => {
        this.loader = false;
        this.toastr.error('Impossible de contacter le serveur', 'Erreur !!!');
      });

  }
  saveRappel() {
    this.loader = true;
    let value = this.formRappel.value;
    let data = {
      "contains": JSON.stringify(value),
      "pays": this.currentPays
    }
    this.authService.saveRappel(data).subscribe(resp => {
      if (resp['responseCode'] == 200) {
        this.loader = false;
        this.toastr.success('Formulaire envoyée avec succès', 'Succès');
        this.closeBTNRappel.nativeElement.click();
      } else {
        this.loader = false;
        this.toastr.error('Erreur sur le serveur', 'Attention !!!');
      }
    }, error => {
      this.loader = false;
      this.toastr.error('Impossible de contacter le serveur', 'Erreur !!!');
    });

  }
  getCurrentProduit(value) {
    return this.listProduits.filter(elm => elm.libelle == value);
  }
  deleteFile(formcontrol) {
    this.customerForm.get(formcontrol).setValue('');
    this.fileName = "";
  }

  nextStep() {
    let valid = true;
    for (let value of this.currentForm.formulaire) {
      if (value.isRequired && this.customerForm.get(value.field).value == '') {
        valid = false;
        this.checkValidity(this.customerForm, value.field);
      }
    }
    if (valid == true) {
      this.currentSection += 1;
      this.validStep = this.currentSection;
      this.currentForm = this.fields[this.currentSection];
      for (let form of this.currentForm.formulaire) {
        if (form.field == 'activite') {
          form.list = this.listActivites;
        }
        if (form.field == 'secteurActivite') {
          form.list = this.listSecteurs;
        }
        if (form.field == 'fonction') {
          form.list = this.listFonctions;
        }
        if (form.field == 'garanties' && this.lien == "auto" && form.list.length != 0) {
          form.list[0]['readonly'] = true;
          form.list[0]['checked'] = true;
        }
      }
    }
  }

  previousStep() {
    if (this.currentForm.addTable == "flotte")
      this.currentSection = this.validStep;
    this.currentSection -= 1;
    this.isFlotte = "";
    this.validStep = this.currentSection;
    this.currentForm = this.fields[this.currentSection];
    for (let form of this.currentForm.formulaire) {
      if (form.field == 'activite') {
        form.list = this.listActivites;
      }
      if (form.field == 'secteurActivite') {
        form.list = this.listSecteurs;
      }
      if (form.field == 'fonction') {
        form.list = this.listFonctions;
      }
    }
  }

  checkValue(e, type: FormArray, formcontrol, list) {
    type = this.customerForm.get(formcontrol) as FormArray;
    if (e.target.checked) {
      type.push(new FormControl(e.target.value));
      list.forEach(elm => {
        if (elm.value == e.target.value)
          elm['checked'] = true;
        if (e.target.value == constante.tcomp && elm.value == constante.tcol) {
          elm['readonly'] = true;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf') {
              form.isRequired = true;
            }
            if (form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.setValidatorsMethode(this.customerForm, ['valeurNeuf']);
          this.clearValidatorsMethode(this.customerForm, ['valeurVenal']);
        }
        if (e.target.value == constante.tcol && elm.value == constante.tcomp) {
          elm['readonly'] = true;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf') {
              form.isRequired = false;
            }
            if (form.field == 'valeurVenal') {
              form.isRequired = true;
            }
          }
          this.setValidatorsMethode(this.customerForm, ['valeurVenal']);
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf']);
        }
      });
    } else {
      const index = type.controls.findIndex(x => x.value === e.target.value);
      type.removeAt(index);
      list.forEach(elm => {
        if (elm.value == e.target.value) {
          elm['checked'] = false;
        }
        if (e.target.value == constante.tcomp && elm.value == constante.tcol) {
          elm['readonly'] = false;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf' || form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf', 'valeurVenal']);
        }
        if (e.target.value == constante.tcol && elm.value == constante.tcomp) {
          elm['readonly'] = false;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf' || form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf', 'valeurVenal']);
        }
      });
    }

  }
  checkValueAuto(e, type: FormArray, formcontrol, list) {
    type = this.customerForm.get(formcontrol) as FormArray;
    if (e.target.checked) {
      type.push(new FormControl(e.target.value));
      list.forEach(elm => {
        if (elm.value == e.target.value) {
          elm['checked'] = true;
          elm['readonly'] = false;
        }
        else {
          elm['readonly'] = true;
          elm['checked'] = false;
        }

        if (e.target.value == constante.tcomp && elm.value == constante.tcol) {
          elm['readonly'] = true;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf') {
              form.isRequired = true;
            }
            if (form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.setValidatorsMethode(this.customerForm, ['valeurNeuf']);
          this.clearValidatorsMethode(this.customerForm, ['valeurVenal']);
        }
        if (e.target.value == constante.tcol && elm.value == constante.tcomp) {
          elm['readonly'] = true;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf') {
              form.isRequired = false;
            }
            if (form.field == 'valeurVenal') {
              form.isRequired = true;
            }
          }
          this.setValidatorsMethode(this.customerForm, ['valeurVenal']);
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf']);
        }
      });
    } else {
      const index = type.controls.findIndex(x => x.value === e.target.value);
      type.removeAt(index);
      list.forEach(elm => {
        elm['checked'] = false;
        elm['readonly'] = false;
        if (e.target.value == constante.tcomp && elm.value == constante.tcol) {
          elm['readonly'] = false;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf' || form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf', 'valeurVenal']);
        }
        if (e.target.value == constante.tcol && elm.value == constante.tcomp) {
          elm['readonly'] = false;
          for (let form of this.currentForm.formulaire) {
            if (form.field == 'valeurNeuf' || form.field == 'valeurVenal') {
              form.isRequired = false;
            }
          }
          this.clearValidatorsMethode(this.customerForm, ['valeurNeuf', 'valeurVenal']);
        }
      });
    }

  }
  checkDate(evt, formcontrol, form) {
    if (evt == 'Invalid Date')
      this[form].get(formcontrol).setValue('');
    else if (evt != null && evt != '') {
      this[form].get(formcontrol).setValue(evt);
    }
    if (evt != null && evt != 'Invalid Date' && (formcontrol == "dateDepart" || formcontrol == "dateMinimum")) {
      this.customerForm.get(formcontrol).setValue(evt);
      this.minDateDepart = new Date(this.customerForm.get(formcontrol).value);
    }

    if (formcontrol == 'dateEffet' && this.customerForm.get('duree').value != '') {
      this.customerForm.get('duree').setValue('');
    }
  }

  checkValidity(g: FormGroup, field) {
    g.get(field).markAsDirty();
    g.get(field).markAsTouched();
  }
  checkValidForm(form) {
    let fonmOk = true;
    let value = {};
    for (let field of Object.keys(form.controls)) {
      const control = form.get(field);
      if (control.valid) value[field] = control.value;
      else {
        fonmOk = false;
        break;
      }
    }
    return fonmOk;
  }
  checkDateArriver(evt, formcontrol) {
    if (evt == 'Invalid Date')
      this.customerForm.get(formcontrol).setValue('');
    if (evt != null && evt != '' && evt != 'Invalid Date' && this.customerForm.get('duree')) {
      let duree = moment(evt).diff(this.customerForm.get('dateDepart').value, 'days');
      this.customerForm.get('duree').setValue(duree);
    }
  }
  currentAction(value, i) {
    this.currentActionValue = value;
    this.currentActionIndex = i;
  }
  initPlainte() {
    this.firstClick = false;
    this.formPlainte = new FormGroup(this.getForm(this.fieldsPlainte));
  }
  initRappel() {
    this.firstClick = false;
    this.formRappel = new FormGroup(this.getForm(this.fieldsRappel));
  }
  initForm(type) {
    this.title = type;
    let form = this.informations[type];
    this.fields = form;
    this.formDetails = this.informations[type];
    this.currentForm = this.fields[0];
    this.libelle = this.fields[0].libelle;
    this.code = this.currentForm.code;
    for (let value of this.fields) {
      for (let form of value.formulaire) {
        if (form.field == 'activite') {
          form.list = this.listActivites;
        }
        if (form.field == 'secteurActivite') {
          form.list = this.listSecteurs;
        }
        if (form.field == 'fonction') {
          form.list = this.listFonctions;
        }
        if (form.field == 'paysResidence') {
          form.list = this.listCountries;
        }
        if (form.field == 'marque') {
          form.list = this.listMarques;
        }
        if (form.field == 'paysResidence') {
          form.list = this.listPays;
        }
        if (form.field == 'destination') {
          form.list = this.listPays;
        }
        if (form.field == 'typeVehicule') {
          form.list = this.listCategories;
        }
        if (form.field == 'garanties' && this.lien == 'voyage') {
          form.list = this.listGarantieVoyage;
        }
      }
    }
    let formulaire = [];
    if (this.fields.length != 0) {
      for (let form of this.fields) {
        formulaire = [...formulaire, ...form.formulaire];
      }
    }
    this.customerForm = new FormGroup(this.getForm(formulaire));
  }

  getForm(fields) {
    let group = {};
    for (let element of fields) {
      let tabValidation = []
      if (element.isRequired && element.validations.length != 0) {
        for (let validation of element.validations) {
          if (validation.name == 'required' && validation.value) {
            tabValidation.push(Validators.required);
          }
          if (validation.name == 'minlength' && validation.value != '') {
            tabValidation.push(Validators.minLength(validation.value));
          }
          if (validation.name == 'maxlength' && validation.value != '') {
            tabValidation.push(Validators.maxLength(validation.value));
          }
          if (validation.name == 'max' && validation.value != '') {
            tabValidation.push(Validators.max(validation.value));
          }
          if (validation.name == 'min' && validation.value != '') {
            tabValidation.push(Validators.min(validation.value));
          }
          if (validation.name == 'pattern' && validation.value != '') {
            tabValidation.push(Validators.pattern(validation.value));
          }
        }
      }
      if (element.type == 'checkbox' || element.type == 'checkbox-multiple')
        group[element.field] = new FormArray([], tabValidation);
      else
        if (element.field == 'dateIncident')
          group[element.field] = new FormControl(new Date(), tabValidation);
        else
          group[element.field] = new FormControl('', tabValidation);
    }
    return group;
  }

  generatePdf() {
    // @ts-ignore
    let doc = new jsPDF();
    document.body.style.zoom = "30%";
    var options = {
      pagesplit: true
    };
    doc.addHTML(this.mondevis.nativeElement, options, function () {
      doc.save('Devis.pdf');
    });
    document.body.style.zoom = "100%";
  }
  checkMontant(field) {
    this.errorMontant = "";
    this.fieldMontant = "";
    if (field == 'valeurBatiment' || field == 'loyer') {
      if (this.customerForm.get('valeurBatiment').value != '' && this.customerForm.get('loyer').value != '') {
        if (parseInt(this.customerForm.get('valeurBatiment').value) < parseInt(this.customerForm.get('loyer').value))
          this.errorMontant = "La valeur du batiment doit être supérieur au loyer";
        this.fieldMontant = field;
      } else {
        this.errorMontant = "";
        this.fieldMontant = "";
      }
    }
    if (field == 'valeurNeuf' || field == 'valeurVenal') {
      if (this.customerForm.get('valeurNeuf').value != '' && this.customerForm.get('valeurVenal').value != '') {
        if (parseInt(this.customerForm.get('valeurNeuf').value) < parseInt(this.customerForm.get('valeurVenal').value))
          this.errorMontant = "La valeur à neuf doit être supérieur à valeur vénale";
        this.fieldMontant = field;
      } else {
        this.errorMontant = "";
        this.fieldMontant = "";
      }
    }
  }

   goToMono() {
    this.router.navigate(['/auto-mono']);
  }


  saveFile(file) {
    this.loader = true;
     let dataFile = new FormData();
     dataFile.append('files', file);
     this.authService.storeFile(dataFile).subscribe( val => {
              this.loader = false;
              if(val){
              this.urlFile = val['urlprod'];
                this.toastr.success("Fichier chargé avec succès", "Succès !!!");
              } 
            }, error => {
              this.loader = false;
              this.toastr.error(error['error']['errors'][0].message, "Erreur !!!");
     });
  }


}
export function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}
